const EPHEMERAL_THREAD_PREFIXES = ['/search/new/', '/computer/tasks/'];
// A freshly-submitted query optimistically navigates using its frontend UUID
// before the backend confirms the thread — the /ask SSE is what actually
// persists it. So while the stream is in flight (or if it failed), that URL has
// no backend-served page, and callers must not treat it as a valid location to
// reload or redirect back to.
//
// `frontendUuid` is the client-generated stream id (`stream.id.description`).
export function isEphemeralNewThreadPath(pathname, frontendUuid) {
    if (!frontendUuid)
        return false;
    return EPHEMERAL_THREAD_PREFIXES.some((prefix) => pathname.startsWith(prefix) && pathname.slice(prefix.length) === frontendUuid);
}
//# sourceMappingURL=ephemeralThread.js.map